import { Button, IconButton, SxProps } from "@mui/material";
import { MouseEventHandler, ReactNode } from "react";
import useGetBreakpoint from "../../hooks/useGetBreakpoint";
import StyledIconButton from "./StyledIconButton";

type Props = {
    children: ReactNode,
    title: string,
    icon: ReactNode,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    variant?: 'outlined' | 'contained',
    onClick?: MouseEventHandler | undefined,
    sx?: SxProps
}

const UXButton = ({ children, icon, title, variant = 'contained', color = 'primary', onClick, sx }: Props) => {
    const { breakpoint } = useGetBreakpoint()

    if (breakpoint == 'xs') {
        return <StyledIconButton
            sx={{ ...sx }}
            size="small"
            onClick={onClick}
            color={color}
            title={title}
            variant={variant}
        >
            {icon}
        </StyledIconButton>
    }

    return (
        <Button
            sx={{ ...sx }}
            size="small"
            onClick={onClick}
            color={color}
            variant={variant}
            title={title}
            endIcon={icon}>
            {children}
        </Button>
    )
}

export default UXButton;